import React, { Component, Suspense } from 'react';
import { matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from './header/Header';
import Footer from './footer/Footer';
import AppTicker from './header/AppTicker';
import properties from '../../modules/ajio-util/properties';
import PopupRoadblock from './PopupRoadblock';
import getHeaderConfigForPage from '../../utils/headerConfig.js';
import AppContainer from '../../AppContainer';
import { isServerRendering } from '../../utils/pageInfo';
import { toggleStoreNav } from '../../actions/webMetaData';
import Loader from '../common/Loader';
import NetworkStatus from '../common/NetworkStatus.js';
import FooterForSeoMsiteNew from './footer/FooterForSeoMsiteNew';
import SeoDropdown from '../common/SeoDropdown';
import MobileShellRoutes from '../../config/mobileshellRoutes.js';
import handleRedirect from '../../utils/redirectUtil';

const JioPrime = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/JioPrime" */ '../../jioprime/components/Mobile/JioPrime'
  )
);

class Layout extends Component {
  constructor() {
    super();
    this.state = {
      isFooterOpen: false
    };
  }

  componentDidMount() {
    handleRedirect();
    if (
      document.querySelector('.apppanel-container:not(.close-app)') &&
      !document.querySelector('.notfound')
    ) {
      if (document.querySelector('.main-content')) {
        document.querySelector('.main-content').style.paddingTop = '110px';
        document.querySelector('.search-container').style.top = '63px';
        if (document.querySelector('.app-header')) {
          document.querySelector('.app-header').style.marginTop = '63px';
          // document.querySelector(".search-block").style.top= "110px";
        }
      }
      if (document.querySelector('.main-content') && document.querySelector('.search-block')) {
        document.querySelector('.main-content').style.paddingTop = '160px';
        document.querySelector('.search-container').style.top = '63px';
        if (document.querySelector('.app-header')) {
          document.querySelector('.app-header').style.marginTop = '63px';
          document.querySelector('.search-block').style.top = '110px';
        }
      }
    } else {
      if (document.querySelector('.notfound') && document.querySelector('.popup-overlay')) {
        document.querySelector('.popup-overlay').style.display = 'none';
        document.getElementsByTagName('body')[0].classList.remove('noScroll');
      }
      if (document.querySelector('.notfound') && document.querySelector('.apppanel-container')) {
        document.querySelector('.apppanel-container').style.display = 'none';
      }
      // if(document.querySelector(".main-content")){
      //   document.querySelector(".main-content").style.paddingTop = '47px';
      // }
      if (document.querySelector('.main-content') && document.querySelector('.search-block')) {
        document.querySelector('.main-content').style.paddingTop = '97px';
      }
      if (document.querySelector('.app-header')) {
        document.querySelector('.app-header').style.marginTop = '0px';
      }
    }
  }

  expandTopStores = () => {
    this.setState(prevState => {
      return { isFooterOpen: !prevState.isFooterOpen };
    });
  };

  render() {
    const {
      metaElementData = [],
      metaData: { showStoreNav = false } = {},
      isIndexMobile = false
    } = this.props;
    const {
      header = true,
      footerSeo = false,
      noHeaderTitle = false,
      isFooter = true,
      pageSelfcareTitle = '',
      accountTitle = '',
      notFoundPage = false,
      metaData: { sis = false, name = '' } = {},
      noHeaderButtons = false
    } = this.props;
    const { isFooterOpen } = this.state;
    let pathname = '';
    let pageType = '';
    let isGPay = false;
    let showRoadBlock = false;
    if (!isServerRendering()) {
      const { location = {} } = window;
      pageType = window.pageType;
      pathname = location.pathname;
      isGPay = sessionStorage.getItem('gpay') === 'true';
      showRoadBlock = properties.getProperty('gpayRoadBlock') === 'ON' && isGPay;
    } else {
      pathname = this.props.location.path ? this.props.location.path : '';
      pageType = '';
    }

    pageType = !notFoundPage ? pageType : 'notFoundPage';
    let config = getHeaderConfigForPage(pathname, pageType, sis);
    const indexMobileComponent = <SeoDropdown isIndexMobile />;
    const categoryMobileSeoComponent = (
      <FooterForSeoMsiteNew
        isFooterOpen={isFooterOpen}
        clickHandler={() => {
          this.expandTopStores();
        }}
      />
    );
    const footerSeoComponent = isIndexMobile ? indexMobileComponent : categoryMobileSeoComponent;
    let matchedShellUrlConfig = [];
    if (!isServerRendering()) {
      matchedShellUrlConfig = MobileShellRoutes.filter(routeConfig =>
        matchPath(location.pathname, routeConfig)
      );
    }
    return (
      <AppContainer>
        <div className={`${sis ? `${name} store-in-store` : 'layout'} mobile-view`} id="layout">
          {!showRoadBlock && config.includes('popuproadblock') ? <PopupRoadblock /> : ''}
          <AppTicker />
          {header && matchedShellUrlConfig && matchedShellUrlConfig.length === 0 ? (
            <Header noHeaderTitle={noHeaderTitle} noHeaderButtons={noHeaderButtons} />
          ) : null}
          {this.props.jioprimepopup && (
            <Suspense fallback={<div />}>
              <JioPrime showCloseBtn />
            </Suspense>
          )}
          {this.props.children}
          {showStoreNav ? (
            <div
              className="modal sis-nav-modal"
              onClick={() => this.props.toggleStoreNav(showStoreNav)}
            />
          ) : (
            ''
          )}
          {footerSeo && footerSeoComponent}
          {isFooter && matchedShellUrlConfig && matchedShellUrlConfig.length === 0 ? (
            <Footer />
          ) : null}
          <Loader name="layout-loader" />
          <NetworkStatus />
        </div>
      </AppContainer>
    );
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, jioprimepopup, metaData, location = {} } = state;
  const { metaElementData = [] } = productsAdditionalInfo;
  return {
    metaElementData,
    jioprimepopup,
    metaData,
    location
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleStoreNav: showStoreNav => {
      dispatch(toggleStoreNav(showStoreNav));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
